import { render, staticRenderFns } from "./PendingTable.vue?vue&type=template&id=374926ac&scoped=true"
import script from "./PendingTable.vue?vue&type=script&lang=ts"
export * from "./PendingTable.vue?vue&type=script&lang=ts"
import style0 from "./PendingTable.vue?vue&type=style&index=0&id=374926ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374926ac",
  null
  
)

export default component.exports